import { ANALYTICS_EVENTS } from './events'

const queryValue = (location, key) => new URLSearchParams(location.search).get(key) || undefined
const stateLabel = (location) => location.state?.name || location.state?.title || location.state?.content || undefined
const queryMetadata = (key = 'id') => ({ location }) => ({ contentId: queryValue(location, key), content: stateLabel(location) })
const analyticsDataMetadata = ({ location }) => {
    const type = queryValue(location, 'type')
    const contentId = queryValue(location, 'content') || (type === 'data' ? 'how-do-you-feel' : type)
    return {
        contentId,
        content: contentId === 'how-do-you-feel' ? 'How are you today?' : stateLabel(location),
    }
}

export const AUTHENTICATED_ROUTE_DEFINITIONS = [
    { path: '/no-permission', exact: true, analytics: ANALYTICS_EVENTS.NO_PERMISSION_VIEWED },
    { path: '/alerts/notification', exact: false, analytics: ANALYTICS_EVENTS.ALERTS_NOTIFICATIONS_VIEWED },
    { path: '/alerts', exact: false, analytics: ANALYTICS_EVENTS.ALERTS_VIEWED },
    { path: '/analytics/search', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_SEARCH_VIEWED },
    { path: '/analytics/student', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_STUDENT_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/analytics/class', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_CLASS_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/analytics/year', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_VIEWED, resolveAnalytics: queryMetadata('year') },
    { path: '/analytics/counsellor', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_COUNSELLOR_VIEWED },
    { path: '/analytics/organization', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_ORGANIZATION_VIEWED },
    { path: '/analytics/custom-report', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_CUSTOM_REPORTS_VIEWED },
    { path: '/analytics/data', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_DATA_VIEWED, resolveAnalytics: analyticsDataMetadata },
    {
        path: '/analytics/pulse/:surveyId?',
        exact: false,
        analytics: ANALYTICS_EVENTS.ANALYTICS_PULSE_VIEWED,
        resolveAnalytics: ({ match, location }) => ({ contentId: match.params.surveyId, content: stateLabel(location) }),
    },
    { path: '/analytics', exact: false, analytics: ANALYTICS_EVENTS.ANALYTICS_VIEWED },
    { path: '/catch-up', exact: false, analytics: ANALYTICS_EVENTS.CATCH_UP_VIEWED },
    { path: '/chat', exact: false, analytics: ANALYTICS_EVENTS.CHAT_VIEWED },
    { path: '/classroom', exact: false, analytics: ANALYTICS_EVENTS.CLASSROOM_VIEWED, resolveAnalytics: queryMetadata('classId') },
    { path: '/content/surveys/:pageID?', exact: false, analytics: ANALYTICS_EVENTS.CONTENT_CREATE_SURVEY_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/content/program/:pageID?', exact: false, analytics: false },
    { path: '/content', exact: true, analytics: ANALYTICS_EVENTS.CONTENT_CREATE_VIEWED },
    { path: '/readytogo', exact: true, analytics: ANALYTICS_EVENTS.CONTENT_LIBRARY_VIEWED },
    { path: '/counseling/student_profile/:pageID?', exact: false, analytics: ANALYTICS_EVENTS.WELLBEING_TRACKER_STUDENT_PROFILE_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/counseling', exact: false, analytics: ANALYTICS_EVENTS.WELLBEING_TRACKER_VIEWED },
    {
        path: '/dashboard',
        exact: false,
        resolveEvent: ({ primaryUI }) => (primaryUI ? ANALYTICS_EVENTS.EARLY_DASHBOARD_VIEWED : ANALYTICS_EVENTS.DASHBOARD_VIEWED),
    },
    { path: '/early/dashboard', exact: false, analytics: ANALYTICS_EVENTS.EARLY_DASHBOARD_VIEWED },
    { path: '/early/classroom/student-select-emotion', exact: false, analytics: ANALYTICS_EVENTS.EARLY_CLASSROOM_STUDENT_EMOTION_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/early/classroom/student-settings', exact: false, analytics: ANALYTICS_EVENTS.EARLY_CLASSROOM_SETTINGS_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/early/classroom', exact: false, analytics: ANALYTICS_EVENTS.EARLY_CLASSROOM_VIEWED, resolveAnalytics: queryMetadata() },
    { path: '/management/upload_user_data', exact: false, analytics: ANALYTICS_EVENTS.MANAGEMENT_UPLOAD_ENGINE_VIEWED },
    { path: '/management/upload', exact: false, analytics: ANALYTICS_EVENTS.MANAGEMENT_UPLOAD_VIEWED },
    { path: '/management', exact: false, analytics: ANALYTICS_EVENTS.MANAGEMENT_VIEWED },
    { path: '/onboarding', exact: false, analytics: ANALYTICS_EVENTS.ONBOARDING_VIEWED },
    { path: '/settings', exact: false, analytics: ANALYTICS_EVENTS.SETTINGS_VIEWED },
    { path: '/videos', exact: false, analytics: ANALYTICS_EVENTS.VIDEOS_VIEWED },
]
